export default __webpack_public_path__ + "static/media/emptyList.e7e89cf2.png";